<template>
  <vue-better-scroll
    class="wrapper"
    ref="scroll"
    :scrollbar="scrollbarObj"
    :pullDownRefresh="pullDownRefreshObj"
    :pullUpLoad="pullUpLoadObj"
    :startY="parseInt(startY)"
    @pulling-down="onPullingDown"
    @pulling-up="onPullingUp"
  >
    <ul class="list-content" style="overflow: hidden;">
      <li
        v-for="(item, i) in list"
        :key="typeof rowKey === 'string' ? item[rowKey] : rowKey(item, i)"
        :style="i > 0 && gutter > 0 ? `margin-top: ${gutter}px` : ''"
      >
        <slot v-bind="{ item, i, list }"></slot>
      </li>
    </ul>
    <empty v-if="!loading && list.length === 0" title="暂无数据"></empty>
  </vue-better-scroll>
</template>
<script>
import VueBetterScroll from "vue2-better-scroll";
import betterScroll from "@/mixin/betterScroll";
import Empty from "@/components/Empty";
export default {
  mixins: [betterScroll],
  components: { Empty,   VueBetterScroll },
  props: {
    loadData: {
      type: Function,
      required: true
    },
    rowKey: {
      type: [String, Function],
      default: () => "id"
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    gutter: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 这个配置可以开启滚动条，默认为 false。当设置为 true 或者是一个 Object 的时候，都会开启滚动条，默认是会 fade 的
      scrollbarObj: {
        fade: true
      },
      // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
      pullDownRefreshObj: {
        threshold: 90,
        stop: 40
      },
      // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
      pullUpLoadObj: {
        threshold: 0,
        txt: {
          more: "加载更多",
          noMore: "没有更多数据了"
        }
      },
      startY: 0, // 纵轴方向初始化位置
      scrollToX: 0,
      scrollToY: 0,
      scrollToTime: 700,
      list: [],
      loading: true,
      pagination: {
        current: 1,
        size: 10
      }
    };
  },
  created() {
    if (!this.lazyLoad) {
      this.getList();
    }
  },
  methods: {
    getList(refresh = false) {
      this.loading = true;
      this.$vux.loading.show();
      if (refresh) {
        this.pagination = {
          current: 1,
          size: 10
        };
      }
      return this.loadData(this.pagination)
        .then(res => {
          this.loading = false;
          const list = res.records;

          if (refresh) {
            this.list = list;
          } else {
            this.list = this.list.concat(list);
          }
          this.pagination = { current: res.current, size: res.size };
          if (res.pages <= res.current) {
            this.$refs.scroll.forceUpdate(false);
          } else {
            this.$refs.scroll.forceUpdate(true);
          }
          if (refresh) {
            this.$nextTick(() => {
              this.$refs.scroll.scrollTo(
                this.scrollToX,
                this.scrollToY,
                this.scrollToTime
              );
            });
          }
        })
        .catch(e => {
          this.$showError(e);
        })
        .finally(() => {
          this.$vux.loading.hide();
          this.loading = false;
        });
    },
    onPullingDown() {
      this.getList(true);
    },
    onPullingUp() {
      this.pagination.current++;
      this.getList();
    },
    refresh() {
      this.getList(true);
    }
  }
};
</script>
